import {enumType} from 'common/enumType';
import * as yup from 'common/yup';
import {DiplomatObject} from 'types/DiplomatObject';

export const FilterTransactionType = enumType({
   ALL: 'Include all transactions',
   SELECTED: 'Select transactions to include',
});
export const FilterPartnerType = enumType({
   ALL: 'Include all partners',
   SELECTED: 'Select partners to include',
});

export const FilterTransactionsNames = {
   transactions: 'transactions',
   partners: 'partners',
   activeOnly: 'activeOnly',
   _type: '_type',
   _byPartners: '_byPartners',
   _filter: '_filter',
} as const;

export const FilterTransactions = yup.object({
   [FilterTransactionsNames.transactions]: yup.array().of(DiplomatObject),
   [FilterTransactionsNames.partners]: yup.array().of(DiplomatObject),
   [FilterTransactionsNames.activeOnly]: yup.bool().default(true),
   [FilterTransactionsNames._type]: yup
      .string()
      .oneOf(FilterTransactionType.keys)
      .default(FilterTransactionType.enum.ALL),
   [FilterTransactionsNames._filter]: yup.string(),
   [FilterTransactionsNames._byPartners]: yup.bool(),
});
export type IFilterTransactions = yup.InferType<typeof FilterTransactions>;
